export const privilegeTypes = [
  { label: "VIP视频", value: 1 },
  { label: "至尊VIP", value: 2 },
  { label: "暗网VIP", value: 3 },
  { label: "星耀VIP", value: 4 },
  { label: "帝王VIP", value: 5 },
  { label: "VIP标识", value: 6 },
  { label: "金币折扣", value: 7 },
  { label: "金币特权", value: 8 },
  { label: "暗网特权", value: 9 },
  { label: "金币返利", value: 10 },
  { label: "AI脱衣", value: 11 },
  { label: "免费私信", value: 12 },
  { label: "下载缓存", value: 13 },
  { label: "黄油解锁", value: 14 },
  { label: "女神裸聊", value: 15 },
  { label: "情趣礼盒", value: 16 },
  { label: "专属线路", value: 17 },
  { label: "专属客服", value: 18 },
  { label: "发帖特权", value: 19 },
  { label: "评论免审", value: 20 },
]